import { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { LinePlot } from "@mui/x-charts/LineChart";
import Box from "@mui/material/Box";

import { UrlApiEnvasado } from "../../../services/apirest";

function ChartGrafica4({ datosChoferVentas, anio }) {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    obtenerRegistrosChoferes();
  }, [datosChoferVentas.id, anio]);

  const obtenerRegistrosChoferes = () => {
    fetch(
      UrlApiEnvasado +
        "/envasado/choferes/registroanual/chofer/" +
        datosChoferVentas.id +
        "/anio/" +
        anio
    )
      .then((data) => data.json())
      .then((data) => {
        const mesesCompletos = Array.from({ length: 12 }, (_, i) => i + 1);

        const formattedData = mesesCompletos.map((mes) => {
          const item = data.find((d) => d.mes === mes);
          return {
            anio: anio,
            mes,
            peso_total_vendido: item
              ? parseFloat(
                  item.peso_total_vendido.replace(/\./g, "").replace(",", ".")
                )
              : 0,
            cantidad_operaciones: item ? item.cantidad_operaciones : 0,
          };
        });

        setChartData(formattedData);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const barSeriesData = chartData.map((item) => item.peso_total_vendido);
  const lineSeriesData = chartData.map((item) => item.cantidad_operaciones);

  const barSeries = [
    {
      data: barSeriesData,
      label: "kg Vendidos",
      type: "bar",
    },
  ];

  const lineSeries = [
    {
      data: lineSeriesData,
      label: "Cantidad de Operaciones",
      type: "line",
    },
  ];

  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "auto",
        }}
      >
        <h2 style={{ textAlign: "center" }}>
          Chofer: {datosChoferVentas.vendedor_nombre}
        </h2>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: 400,
          width: "100%",
          margin: "auto",
        }}
      >
        {chartData.length > 0 ? (
          <>
            <BarChart
              xAxis={[
                {
                  id: "Mes",
                  data: [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre",
                  ],
                  scaleType: "band",
                },
              ]}
              series={barSeries}
              slotProps={{
                legend: {
                  direction: "row",
                  position: {
                    vertical: "top",
                    horizontal: "middle",
                  },
                  itemMarkWidth: 20,
                  itemMarkHeight: 6,
                  markGap: 5,
                  itemGap: 10,
                },
              }}
              style={{ height: "100%", width: "100%" }}
            />
            <LinePlot
              xAxis={[
                {
                  id: "Mes",
                  data: [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre",
                  ],
                  scaleType: "band",
                },
              ]}
              series={lineSeries}
              slotProps={{
                legend: {
                  direction: "row",
                  position: {
                    vertical: "top",
                    horizontal: "middle",
                  },
                  itemMarkWidth: 20,
                  itemMarkHeight: 6,
                  markGap: 5,
                  itemGap: 10,
                },
              }}
              style={{
                height: "100%",
                width: "100%",
                position: "absolute",
                pointerEvents: "none",
              }}
            />
          </>
        ) : null}
      </Box>
    </>
  );
}

export default ChartGrafica4;
